/* src/app/shared/components/ship-details-actions/ship-details-action-icon.component.scss */
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 0.65em;
  color: #004791;
  cursor: pointer;
}
.wrapper.disabled {
  pointer-events: none;
  opacity: 0.2;
}
.wrapper:hover img {
  transform: scale(1.2);
}
.wrapper:hover .label-text {
  font-weight: 600;
}
.wrapper img {
  transform: scale(1);
  transition: transform 0.15s ease-in-out;
}
.wrapper .label-text {
  font-size: 0.8em;
  text-align: center;
  line-height: 1.5;
}
.spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: not-allowed;
}
:host(.ship-details-action-icon) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
  font-size: 1rem;
  position: relative;
}
/*# sourceMappingURL=ship-details-action-icon.component.css.map */
